import cleanedFilename from '~/util/cleanedFilename';

export default {
  STREET: `${cleanedFilename(__filename)}-street`,
  POSTCODE: `${cleanedFilename(__filename)}-postcode`,
  CITY: `${cleanedFilename(__filename)}-city`,
  HOUSE_NUMBER: `${cleanedFilename(__filename)}-house-number`,
  HOUSE_NUMBER_ADDITION: `${cleanedFilename(__filename)}-house-number-addition`,
};
